import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ExternalLink, Copy } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/api";

export default function OffersPanel() {
  const [offers, setOffers] = useState(null);
  useEffect(() => { api.get("/admin/offers").then(({ data }) => setOffers(data)); }, []);
  const copy = (token) => { navigator.clipboard?.writeText(`${window.location.origin}/offer/${token}`); toast.success("Offer link copied"); };
  return (
    <div data-testid="admin-offers">
      <p className="text-[#7c5230] text-xs tracking-[0.25em] uppercase">Trade desk</p>
      <h1 className="mt-3 font-display text-4xl md:text-5xl font-light text-[#10271a]">Offers</h1>
      <p className="mt-3 text-[#5e6b61] max-w-xl">Create an offer from any wholesale enquiry in the <Link to="/admin" className="underline">enquiries list</Link>. Buyers receive a private link they can forward internally.</p>
      <div className="mt-8 rounded-3xl border border-[#10271a]/10 bg-[#faf6ec] overflow-hidden">
        {offers === null && <p className="p-8 text-[#5e6b61]">Loading...</p>}
        {offers?.length === 0 && <p className="p-8 text-[#5e6b61]" data-testid="offers-empty">No offers yet.</p>}
        <ul className="divide-y divide-[#10271a]/10">
          {offers?.map((o) => (
            <li key={o.id} className="p-5 md:p-6 flex flex-wrap items-center justify-between gap-4" data-testid={`offer-row-${o.reference}`}>
              <div>
                <div className="flex items-center gap-3"><span className="font-mono text-xs text-[#7c5230]">{o.reference}</span><span className="text-[10px] tracking-[0.18em] uppercase text-[#5e6b61]">from {o.enquiry_reference}</span></div>
                <p className="mt-1 font-display text-2xl text-[#10271a] leading-tight">{o.buyer.company}</p>
                <p className="text-sm text-[#5e6b61] mt-1">{o.currency} {o.grand_total.toLocaleString()} · valid until {o.valid_until} · {o.views} view{o.views === 1 ? "" : "s"} · email {String(o.email_status || "pending").slice(0, 30)}</p>
              </div>
              <div className="flex items-center gap-2">
                <button type="button" onClick={() => copy(o.token)} data-testid={`copy-offer-${o.reference}`} className="inline-flex items-center gap-2 px-3 py-2 rounded-full text-[11px] tracking-[0.1em] uppercase font-semibold border border-[#10271a]/15 text-[#10271a]/75 hover:border-[#1f4a33]"><Copy size={13} /> Copy link</button>
                <a href={`/offer/${o.token}`} target="_blank" rel="noreferrer" data-testid={`open-offer-${o.reference}`} className="inline-flex items-center gap-2 px-3 py-2 rounded-full text-[11px] tracking-[0.1em] uppercase font-semibold bg-[#1f4a33] text-[#f6f1e7] hover:bg-[#10271a]"><ExternalLink size={13} /> Open</a>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
